import { _ep0, _mw0, command } from "../commandBuilder";
import { CreateChurchInvitation$ } from "../schemas/schemas_0";
export class CreateChurchInvitationCommand extends command(_ep0, _mw0, "CreateChurchInvitation", CreateChurchInvitation$) {
}
